import React from 'react';
import { VENUE_NAME, VENUE_LOCATION, IMAGES } from '../constants';

export const Venue: React.FC = () => {
  return (
    <div className="bg-black text-white py-12 md:py-24">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <div className="space-y-8">
          <h2 className="text-sm tracking-[0.5em] uppercase text-[#D4C4A8]/80">The Venue</h2>
          <h3 className="font-serif-display text-4xl md:text-6xl">{VENUE_NAME}</h3>
          
          <div className="w-16 h-px bg-[#D4C4A8]/30 mx-auto" />
          
          {/* Venue Image with Rounded Corners - Grayscale removed to show original color */}
          <div className="py-4">
            <img 
              src={IMAGES.venue} 
              alt="Enterkine Country House Resort" 
              className="w-full h-auto rounded-[2.5rem] shadow-2xl transition-all duration-700 hover:scale-[1.02]"
            />
          </div>
          
          <p className="text-lg text-gray-400 font-light leading-relaxed">
            Nestled in the heart of the beautiful Ayrshire countryside, Enterkine House 
            is a stunning country house resort that offers the perfect romantic setting 
            for our special day. We can't wait to share its charm and elegance with you.
          </p>
          
          <div className="flex flex-col items-center space-y-4 pt-4">
            <div className="p-3 rounded-full border border-[#D4C4A8]/20">
              <svg className="w-6 h-6 text-[#D4C4A8]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <div className="text-gray-300">
              <p className="font-medium tracking-wide">{VENUE_NAME}</p>
              <p className="text-sm font-light opacity-80">{VENUE_LOCATION}</p>
            </div>
            
            <a 
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(VENUE_NAME + ' ' + VENUE_LOCATION)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mt-4 text-[#D4C4A8] hover:text-white text-sm font-medium tracking-[0.2em] border-b border-[#D4C4A8]/30 pb-1 transition-all"
            >
              VIEW ON GOOGLE MAPS
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};